import React from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';

import { Icon, Loader, IconButton, } from 'rsuite';
import { Table, } from 'react-bootstrap';
import { Paper, Grid, Container, TableContainer } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import CorpoAlertabackups from '../../components/CorpoAlertaBackups';

import '../Main/Main.css';


function BackupAlerts({ backupAlerts, loading, onSendEmail, }) {
  return (
    <Grid item xs={12}>
      <Container
        component={Paper}
        maxWidth="xl"
      >
        <br />

        <div>
          <Alert severity="error">
            Itens que precisam de atenção até agora (Hora atual: {moment().format('DD/MM/YYYY, HH:mm:SS')})
          </Alert>
          <br />

          <TableContainer maxWidth="xl">
            <Table responsive hover>
              <thead>
                <tr>
                  <td className="TableNames">Empresa</td>
                  <td className="TableNames">HOST</td>
                  <td className="TableNames">Backup</td>
                  <td className="TableNames">Status</td>
                  <td className="TableNames">Field</td>
                  <td className="TableNames">Data</td>
                  <td className="TableNames">Observações</td>
                </tr>
              </thead>
              {
                loading ?
                <Loader content="loading" /> :
                backupAlerts
                  .map((body) => {
                    return (
                      <CorpoAlertabackups
                        key={body.id}
                        data={body}
                      />
                    );
                })
              }
            </Table>

            <div className="ButtonSend">
              <IconButton
                appearance="ghost"
                onClick={onSendEmail}
                icon={<Icon icon="send" />}
              >
                Enviar E-mail
              </IconButton>
            </div>

            <br />
          </TableContainer>
        </div>
        <br />
      </Container>
    </Grid>
  );
}

export default BackupAlerts;
